export const GET_CUSTOMER_INTERACTION_NOTIFICATION_PREVIEW = `
  query GetCustomerInteractionNotificationPreview($customerInteractionId: ID!, $templateId: ID!, $transferRequestId: Int, $customComment: String, $recipientOverride: String) {
    customerInteractionNotificationPreview(customerInteractionId: $customerInteractionId, templateId: $templateId, transferRequestId: $transferRequestId, customComment: $customComment, recipientOverride: $recipientOverride) {
      preview {
        templateName
        templateType
        notificationType
        recipient
        subject
        body
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_COMPANY_INTERACTION_NOTIFICATION_PREVIEW = `
  query GetCompanyInteractionNotificationPreview($companyInteractionId: ID!, $templateId: ID!, $customComment: String) {
    companyInteractionNotificationPreview(companyInteractionId: $companyInteractionId, templateId: $templateId, customComment: $customComment) {
      preview {
        templateName
        templateType
        notificationType
        recipient
        subject
        body
      }
      errors {
        property
        description
      }
    }
  }
`;
